class RocketVideoElm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.playVideo();
  }
  playVideo() {
    const playBtn = this.querySelector(".play-video-btn");
    if (!playBtn) {
      return;
    }
    const videoDsk = this.querySelector("video.video-dsk");
    const videoMb = this.querySelector("video.video-mb");
    if (window.innerWidth >= 768) {
      playBtn?.addEventListener("click", () => {
        videoDsk.play();
        playBtn.classList.add("hidden");
      });
    } else {
      playBtn?.addEventListener("click", () => {
        videoMb.play();
        playBtn.classList.add("hidden");
      });
    }
    if (videoDsk) {
      videoDsk.addEventListener("click", () => {
        if (videoDsk.paused) {
          videoDsk.play();
          playBtn.classList.add("hidden");
        } else {
          videoDsk.pause();
          playBtn.classList.remove("hidden");
        }
      });
    }
    if (videoMb) {
      videoMb.addEventListener("click", () => {
        if (videoMb.paused) {
          videoMb.play();
          playBtn.classList.add("hidden");
        } else {
          videoMb.pause();
          playBtn.classList.remove("hidden");
        }
      });
    }
  }
}
customElements.define("rocket-video-elm", RocketVideoElm);